import { ToastContainer } from '@bfe/moly';
import { DirectionleftIcon } from '@bfe/moly-icons';
import classNames from 'classnames';
import { lazy, Suspense, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { PageLevel } from '@/components/PageContainer';
import PageHeader from '@/components/PageContainer/PageHeader';
import Spin from '@/components/Spin';
import { useI18nContext } from '@/i18n/I18n';
import { useUserStore } from '@/store/useUser';
import storage from '@/utils/storage';
import { isMobile } from '@/utils/ua';

import DeleteAccountUnableReasonModal from '../AccountInfo/components/DeleteAccount/DeleteAccountUnableReasonModal';
import useDeleteAccountPrecheck, {
  DeleteAccountPrecheckResultKey,
} from '../AccountInfo/components/DeleteAccount/useDeleteAccountPrecheck';
import styles from './index.module.less';

const DeleteAccountEntry = lazy(() => import('./Entry'));

const Loading = () => {
  return (
    <div
      className={classNames(
        styles['delete-account-page-card'],
        styles['delete-account-page-loading'],
      )}
    ></div>
  );
};

const DeleteAccount = () => {
  const [$t] = useI18nContext();
  const { loading, profile } = useUserStore();
  const navigator = useNavigate();

  const {
    preChecking,
    precheck,
    businessUnitDetails,
    showErrorsModal,
    constants,
  } = useDeleteAccountPrecheck();

  useEffect(() => {
    const deleteAccountPrecheckResult = storage.session.get(
      DeleteAccountPrecheckResultKey,
    );
    if (
      !loading &&
      (!deleteAccountPrecheckResult ||
        JSON.parse(deleteAccountPrecheckResult)?.[profile.id] !== '1')
    ) {
      precheck({});
    }
  }, [loading, profile.id]);

  return (
    <>
      <div className={styles['delete-account-page']}>
        {isMobile() ? (
          <Link
            className={styles['delete-account-header-back-btn']}
            to="/app/user/account-info"
          >
            <DirectionleftIcon width={20} height={20} />
          </Link>
        ) : (
          <PageHeader
            pageLevel={PageLevel.sub}
            breadItems={[
              {
                key: '1',
                label: () => (
                  <Link to="/app/user/account-info">
                    {$t('accountBaseInfo')}
                  </Link>
                ),
              },
              {
                key: '2',
                title: $t('deleteAccount'),
              },
            ]}
          ></PageHeader>
        )}
        <div
          className={classNames(
            styles['delete-account-page-card'],
            isMobile() && styles['delete-account-page-card-h5'],
          )}
        >
          <div className={styles['title']}>{$t('deleteAccount')}</div>
          <Spin spinning={loading || preChecking}>
            <Suspense fallback={<Loading />}>
              <DeleteAccountEntry />
            </Suspense>
          </Spin>
        </div>
      </div>
      <ToastContainer />
      <DeleteAccountUnableReasonModal
        businessUnitDetails={businessUnitDetails}
        visible={showErrorsModal}
        constants={constants}
        onClose={() => {
          navigator('/app/user/account-info');
        }}
      />
    </>
  );
};

export default DeleteAccount;
